import React from "react";
import CustomizationViewPublishButtons from "../helpers/CustomizationViewPublishButtons";
import ConfigurationButtonColorsCard from "../cards/ConfigurationButtonColorsCard";
import ConfigurationFontCard from "../cards/ConfigurationFontCard";
import ConfigurationModalBorderRadiusCard from "../cards/ConfigurationModalBorderRadiusCard";
import ConfigurationSelectionButtonBorderRadiusCard from "../cards/ConfigurationSelectionButtonBorderRadiusCard";
import { SectionHeaderWrapper } from "../../../../shared/SectionHeaderWrapper";

const ConfigurationAppearanceSettingsPage = () => {
  return (
    <SectionHeaderWrapper
      title="Appearance"
      subtitle="Customize Merge Link's appearance to feel native to your experience"
      buttons={<CustomizationViewPublishButtons />}
    >
      <>
        <ConfigurationFontCard />
        <ConfigurationButtonColorsCard />
        <ConfigurationSelectionButtonBorderRadiusCard />
        <ConfigurationModalBorderRadiusCard />
      </>
    </SectionHeaderWrapper>
  );
};

export default ConfigurationAppearanceSettingsPage;
